import { render, staticRenderFns } from "./FavoriteButtonIcon.vue?vue&type=template&id=63f8741e"
import script from "./FavoriteButtonIcon.vue?vue&type=script&lang=js"
export * from "./FavoriteButtonIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports